import BlockComposition from "../modules/block-composition";

const SingleProduct = {
  init() {
    BlockComposition.init();
  },
};

export default SingleProduct;
